/**
 * CSS class name constants used throughout the application.
 * Centralizing these constants helps prevent typos and makes refactoring easier.
 */

const CSS_CLASSES = {
  /**
   * CSS class applied to document.body to hide the AppBar toggle button.
   * Used in CustomReports when entering edit mode to provide a distraction-free editing experience.
   * @see src/index.css for the corresponding CSS rule
   */
  HIDE_APPBAR_TOGGLE: 'hide-appbar-toggle',
};

export default CSS_CLASSES;
